import { Briefcase, MapPin } from "lucide-react";
import Reveal from "@/components/ui/Reveal";
import { FOCUS_AREAS, PROFILE, STATS } from "@/data/portfolio";

export default function AboutWindow() {
  return (
    <div className="space-y-6 p-6 sm:p-7" data-testid="about-content">
      <div>
        <p className="eyebrow">cat about.txt</p>
        <h2 className="mt-2 font-display text-2xl font-bold tracking-tight sm:text-3xl">
          Banking-grade backend engineer, <span className="text-grad-blue">reconciliation nerd</span>.
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-slate-300">{PROFILE.summary}</p>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" data-testid="about-stats">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.06}>
            <div className="glass-soft h-full rounded-xl p-4 transition-colors duration-200 hover:bg-white/[.07]">
              <p className="font-display text-2xl font-extrabold text-grad-blue">{s.value}</p>
              <p className="mt-1 font-mono text-[10px] leading-snug text-slate-500">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="space-y-3">
        <p className="eyebrow">currently</p>
        <div className="flex flex-wrap gap-2">
          <span className="flex items-center gap-1.5 rounded-full border border-sonoma/30 bg-sonoma/10 px-3 py-1.5 font-mono text-[11px] text-sky-300">
            <Briefcase size={11} /> SDE I @ Hatio Innovations (A BillDesk Company)
          </span>
          <span className="flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3 py-1.5 font-mono text-[11px] text-slate-300">
            <MapPin size={11} /> Bengaluru, India
          </span>
        </div>
        <div className="flex flex-wrap gap-2" data-testid="about-focus-areas">
          {FOCUS_AREAS.map((f) => (
            <span key={f} className="rounded-full border border-white/10 bg-white/[.04] px-3 py-1.5 font-mono text-[11px] text-slate-400">
              {f}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
